// Courbe de débit (2 dernières minutes). L'échelle part de 0 : une chute de débit se voit tout de suite.
import { useId } from "react";

export function Sparkline({ values, height = 32, color = "var(--color-accent)", className }: {
  values: number[]; height?: number; color?: string; className?: string;
}) {
  const gradientId = useId();
  const width = 120;
  if (values.length < 2) {
    return <svg viewBox={`0 0 ${width} ${height}`} className={className} preserveAspectRatio="none" aria-hidden="true" />;
  }
  const max = Math.max(...values, 1);
  const step = width / (values.length - 1);
  const y = (v: number) => height - 1 - (v / max) * (height - 4);
  const points = values.map((v, i) => `${(i * step).toFixed(1)},${y(v).toFixed(1)}`);
  const last = values.at(-1) ?? 0;
  return (
    <svg viewBox={`0 0 ${width} ${height}`} className={className} preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor={color} stopOpacity="0.35" />
          <stop offset="1" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={`0,${height} ${points.join(" ")} ${width},${height}`} fill={`url(#${gradientId})`} />
      <polyline points={points.join(" ")} fill="none" stroke={color} strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
      {/* point final : un trait vertical, qui ne se déforme pas avec preserveAspectRatio="none" */}
      <line x1={width} x2={width} y1={y(last) - 2} y2={y(last) + 2} stroke={color} strokeWidth="3"
        vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
